import { render } from "./WorkGroupListPage.vue?vue&type=template&id=0ae1da04"
import script from "./WorkGroupListPage.vue?vue&type=script&lang=js"
export * from "./WorkGroupListPage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__